/**
 * Storefront Plan gifts punchcard (wizard-2 plan overview + buybox-2 Subscribe).
 * Shown only when rewards_v1:on. Instant popups via data-open-flavor-modal.
 */
(function (global) {
  'use strict';

  var FLAVOR_ORDER = ['rund', 'kip', 'vis'];

  var IMAGES = {
    scoop: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/punchcard_-_scoop.webp?v=1788258020',
    guide:
      'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/transition_guide.webp?v=1780909610',
    sardine:
      'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/punchcard_-_Sardine_Oil.webp?v=1788258021',
    tripe: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/punchcard_-_tripe.webp?v=1788258021',
    sample: 'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/transition_pack_DONT_USE.webp?v=1',
    credit5:
      'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/credit_5_blue_bg.webp?v=1790327677',
    duck_trainers:
      'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/transition_pack_DONT_USE.webp?v=1',
    beef_trainers:
      'https://cdn.shopify.com/s/files/1/0919/3534/2856/files/transition_pack_DONT_USE.webp?v=1',
  };

  /** Box1 gifts: prefer product featured image (variant Ajax often has none / transparent punch art). */
  var PRODUCT_HANDLE_BY_VARIANT = {
    '54147127148808': 'transitiegids',
    '58329766461704': 'scoop',
  };

  var SAMPLE_VARIANT_BY_FLAVOR = {
    rund: '58584603427080',
    kip: '58584603459848',
    vis: '58584603492616',
  };

  var SAMPLE_LABEL_FALLBACK = {
    rund: { nl: 'Proefzakje Rund', en: 'Beef sample' },
    kip: { nl: 'Proefzakje Kip', en: 'Chicken sample' },
    vis: { nl: 'Proefzakje Vis', en: 'Fish sample' },
  };

  var INSTANT_BY_KEY = {
    sardine: 'sardine-oil',
    tripe: 'lamb-tripe',
    beef_trainers: 'beef-trainers',
    duck_trainers: 'duck-trainers',
  };

  var INSTANT_BY_SAMPLE = {
    rund: 'beef-sample',
    kip: 'chicken-sample',
    vis: 'fish-sample',
  };

  var PUNCH_SLOTS = [
    {
      doos: 1,
      key: 'scoop',
      type: 'box1_item',
      box1Key: 'scoop',
      imageKey: 'scoop',
      shopifyVariantId: '58329766461704',
      label: { nl: 'Maatschep', en: 'Scoop' },
    },
    {
      doos: 1,
      key: 'guide',
      type: 'box1_item',
      box1Key: 'guide',
      imageKey: 'guide',
      shopifyVariantId: '54147127148808',
      label: { nl: 'Transitiegids', en: 'Transition guide' },
    },
    {
      doos: 2,
      key: 'sardine',
      type: 'product',
      imageKey: 'sardine',
      shopifyVariantId: '58163254657288',
      label: { nl: 'Sardineolie', en: 'Sardine oil' },
    },
    {
      doos: 3,
      key: 'tripe',
      type: 'product',
      imageKey: 'tripe',
      shopifyVariantId: '58584639537416',
      label: { nl: 'Lamspens', en: 'Lamb Tripe' },
    },
    { doos: 4, key: 'empty4', type: 'empty', imageKey: null, label: { nl: '', en: '' } },
    {
      doos: 5,
      key: 'sample',
      type: 'sample',
      imageKey: 'sample',
      label: { nl: 'Proefzakje', en: 'Sample bag' },
    },
    { doos: 6, key: 'empty6', type: 'empty', imageKey: null, label: { nl: '', en: '' } },
    {
      doos: 7,
      key: 'duck_trainers',
      type: 'product',
      imageKey: 'duck_trainers',
      shopifyVariantId: '58724667097352',
      label: { nl: 'Eend Trainers', en: 'Duck Trainers' },
    },
    { doos: 8, key: 'empty8', type: 'empty', imageKey: null, label: { nl: '', en: '' } },
    {
      doos: 9,
      key: 'beef_trainers',
      type: 'product',
      imageKey: 'beef_trainers',
      shopifyVariantId: '58724644520200',
      label: { nl: 'Rund Trainers', en: 'Beef Trainers' },
    },
  ];

  /** @type {Record<string, { title?: string, name?: string, imageUrl?: string, productImageUrl?: string, productTitle?: string }>} */
  var variantMetaCache = {};
  /** @type {Record<string, { imageUrl?: string, title?: string }>} */
  var productMetaCache = {};

  function localeFromDoc() {
    var lang = (document.documentElement && document.documentElement.getAttribute('lang')) || 'nl';
    return String(lang).toLowerCase().indexOf('en') === 0 ? 'en' : 'nl';
  }

  function giftCount(slots) {
    return (slots || []).filter(function (s) {
      return s && s.type !== 'empty';
    }).length;
  }

  function punchTitleCopy(locale, count) {
    var n = typeof count === 'number' && count > 0 ? count : 7;
    if (locale === 'en') return n + ' free gifts';
    return n + ' gratis cadeaus';
  }

  function rewardsExperimentOn() {
    if (typeof global.bzRewardsExperimentOn === 'function') {
      try {
        return !!global.bzRewardsExperimentOn();
      } catch (e) {}
    }
    var raw = '';
    try {
      if (typeof global.bzReadExperiments === 'function') raw = String(global.bzReadExperiments() || '');
    } catch (e2) {}
    return /(?:^|,)rewards_v1:on(?:,|$)/.test(raw);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeFlavor(raw) {
    var s = String(raw || '')
      .trim()
      .toLowerCase();
    if (s === 'beef' || s === 'rund' || s === 'rundvlees') return 'rund';
    if (s === 'chicken' || s === 'kip' || s === 'kippenvlees') return 'kip';
    if (s === 'fish' || s === 'vis' || s === 'witvis' || s === 'wit_kleine_vis') return 'vis';
    return '';
  }

  function allergicFlavorIds(allergies) {
    var ids = [];
    (allergies || []).forEach(function (token) {
      var f = normalizeFlavor(token);
      if (f && ids.indexOf(f) === -1) ids.push(f);
    });
    return ids;
  }

  function pickSampleReward(planFlavors, allergies) {
    var onPlan = {};
    (planFlavors || []).forEach(function (f) {
      var n = normalizeFlavor(f);
      if (n) onPlan[n] = true;
    });
    var blocked = {};
    allergicFlavorIds(allergies).forEach(function (f) {
      blocked[f] = true;
    });
    var eligible = FLAVOR_ORDER.filter(function (flavor) {
      return !onPlan[flavor] && !blocked[flavor] && SAMPLE_VARIANT_BY_FLAVOR[flavor];
    });
    if (!eligible.length) {
      return { kind: 'credit5', alternateFlavors: [] };
    }
    return {
      kind: 'sample',
      flavor: eligible[0],
      variantId: SAMPLE_VARIANT_BY_FLAVOR[eligible[0]],
      alternateFlavors: eligible.slice(1),
    };
  }

  function variantNumericId(raw) {
    return String(raw || '').replace(/\D/g, '');
  }

  function fetchProductMeta(handle) {
    var h = String(handle || '').trim();
    if (!h) return Promise.resolve(null);
    if (productMetaCache[h] && productMetaCache[h].imageUrl) {
      return Promise.resolve(productMetaCache[h]);
    }
    return fetch('/products/' + encodeURIComponent(h) + '.js')
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data) return null;
        var featured = data.featured_image || '';
        if (featured && typeof featured === 'object') featured = featured.src || featured.url || '';
        if (featured && featured.indexOf('//') === 0) featured = 'https:' + featured;
        var meta = {
          title: data.title ? String(data.title) : '',
          imageUrl: featured ? String(featured) : '',
        };
        productMetaCache[h] = meta;
        return meta;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchVariantMeta(variantId) {
    var id = variantNumericId(variantId);
    if (!id) return Promise.resolve(null);
    if (variantMetaCache[id] && (variantMetaCache[id].title || variantMetaCache[id].imageUrl || variantMetaCache[id].productImageUrl)) {
      return Promise.resolve(variantMetaCache[id]);
    }
    var productHandle = PRODUCT_HANDLE_BY_VARIANT[id] || '';
    var productPromise = productHandle ? fetchProductMeta(productHandle) : Promise.resolve(null);

    return Promise.all([
      fetch('/variants/' + id + '.js')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function () {
          return null;
        }),
      productPromise,
    ]).then(function (results) {
      var data = results[0];
      var productMeta = results[1];
      if (!data && !productMeta) return null;
      data = data || {};
      var variantTitle = data.title || data.public_title || '';
      var fullName = data.name || '';
      var imageUrl = '';
      if (data.featured_image) {
        if (typeof data.featured_image === 'string') imageUrl = data.featured_image;
        else imageUrl = data.featured_image.src || data.featured_image.url || '';
      }
      if (!imageUrl && data.image) {
        imageUrl = typeof data.image === 'string' ? data.image : data.image.src || '';
      }
      var productImageUrl = (productMeta && productMeta.imageUrl) || '';
      var productTitle = (productMeta && productMeta.title) || '';
      var meta = {
        title: variantTitle ? String(variantTitle) : fullName ? String(fullName) : '',
        name: fullName ? String(fullName) : '',
        imageUrl: imageUrl ? String(imageUrl) : '',
        productImageUrl: productImageUrl ? String(productImageUrl) : '',
        productTitle: productTitle ? String(productTitle) : '',
      };
      variantMetaCache[id] = meta;
      return meta;
    });
  }

  function buildSlots(opts) {
    var shippedCount = 0;
    var box1 = (opts && opts.box1Freebies) || { scoop: true, guide: true };
    var samplePick =
      (opts && opts.samplePick) || pickSampleReward(opts && opts.planFlavors, opts && opts.allergies);
    var locale = (opts && opts.locale) || localeFromDoc();

    return PUNCH_SLOTS.map(function (slot) {
      var state = 'future';
      if (slot.doos <= shippedCount) state = 'past';
      else if (slot.doos === shippedCount + 1) state = 'current';

      var hidden = false;
      if (slot.box1Key === 'scoop' && !box1.scoop) hidden = true;
      if (slot.box1Key === 'guide' && !box1.guide) hidden = true;
      if (hidden) return null;

      var out = {
        doos: slot.doos,
        key: slot.key,
        type: slot.type,
        box1Key: slot.box1Key || '',
        imageKey: slot.imageKey,
        imageUrl: slot.imageKey ? IMAGES[slot.imageKey] || '' : '',
        label: Object.assign({}, slot.label),
        state: state,
        modalable: false,
        instantModal: '',
        isCredit: false,
        sampleFlavor: '',
        shopifyVariantId: slot.shopifyVariantId || '',
      };

      if (slot.type === 'product') {
        out.modalable = true;
        out.instantModal = INSTANT_BY_KEY[slot.key] || '';
      }

      if (slot.type === 'sample') {
        if (samplePick.kind === 'credit5') {
          out.isCredit = true;
          out.imageKey = 'credit5';
          out.imageUrl = IMAGES.credit5;
          out.label = { nl: '€5 tegoed', en: '€5 credit' };
          out.modalable = false;
          out.shopifyVariantId = '';
        } else {
          out.sampleFlavor = samplePick.flavor;
          out.shopifyVariantId = samplePick.variantId || '';
          out.modalable = true;
          out.instantModal = INSTANT_BY_SAMPLE[samplePick.flavor] || '';
          var fb = SAMPLE_LABEL_FALLBACK[samplePick.flavor] || out.label;
          out.label = { nl: fb.nl, en: fb.en };
          var cached = variantMetaCache[variantNumericId(samplePick.variantId)];
          if (cached && cached.title) {
            out.label = { nl: cached.title, en: cached.title };
          }
          if (cached && cached.imageUrl) out.imageUrl = cached.imageUrl;
        }
      }

      var cachedSlot = variantMetaCache[variantNumericId(out.shopifyVariantId)];
      if (cachedSlot) {
        if (out.type === 'box1_item') {
          if (cachedSlot.productImageUrl) out.imageUrl = cachedSlot.productImageUrl;
          else if (cachedSlot.imageUrl) out.imageUrl = cachedSlot.imageUrl;
          if (cachedSlot.productTitle) {
            out.label = { nl: cachedSlot.productTitle, en: cachedSlot.productTitle };
          }
        } else {
          if (cachedSlot.imageUrl) out.imageUrl = cachedSlot.imageUrl;
          if (out.type === 'sample' && !out.isCredit) {
            var st = cachedSlot.name || cachedSlot.title;
            if (st) out.label = { nl: st, en: st };
          }
          if (out.type === 'product' && cachedSlot.title) {
            out.label = { nl: cachedSlot.title, en: cachedSlot.title };
          }
        }
      }

      return out;
    }).filter(Boolean);
  }

  function joinGiftNameParts(parts, locale) {
    var list = (parts || []).filter(Boolean);
    if (!list.length) return '';
    var and = locale === 'en' ? ' and ' : ' en ';
    if (list.length === 1) return list[0];
    if (list.length === 2) return list[0] + and + list[1];
    return list.slice(0, -1).join(', ') + and + list[list.length - 1];
  }

  function nextBanner(slots, locale) {
    var nextDoos = 1;
    var gifts = (slots || []).filter(function (s) {
      return s.doos === nextDoos && s.type !== 'empty';
    });
    if (!gifts.length) {
      var empty = (slots || []).find(function (s) {
        return s.doos === nextDoos;
      });
      if (!empty) return null;
      gifts = [empty];
    }

    return {
      nextDoos: nextDoos,
      gifts: gifts.map(function (slot) {
        return {
          giftLabel: (slot.label && (slot.label[locale] || slot.label.nl)) || '',
          giftKey: slot.key || '',
          modalable: !!slot.modalable && !!slot.instantModal,
          instantModal: slot.instantModal || '',
          isCredit: !!slot.isCredit,
          isEmptySlot: slot.type === 'empty',
        };
      }),
    };
  }

  function renderBanner(root, banner, locale) {
    var el = root.querySelector('[data-bz-sf-punch-banner]');
    var textEl = root.querySelector('[data-bz-sf-punch-banner-text]');
    if (!el || !textEl) return;
    if (!banner || !banner.gifts || !banner.gifts.length) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var gifts = banner.gifts;

    if (gifts.length === 1 && gifts[0].isCredit) {
      textEl.textContent =
        locale === 'en'
          ? "You'll get €5 credit on your next box!"
          : 'Je krijgt €5 tegoed op je volgende doos!';
      return;
    }
    if (gifts.length === 1 && gifts[0].isEmptySlot) {
      textEl.textContent =
        locale === 'en'
          ? "You'll get 1 free " + gifts[0].giftLabel + ' in box ' + banner.nextDoos + '!'
          : 'Je krijgt 1 gratis ' + gifts[0].giftLabel + ' in doos ' + banner.nextDoos + '!';
      return;
    }

    function giftButtonHtml(gift) {
      if (!gift.giftLabel) return '';
      if (!gift.modalable) return escapeHtml(gift.giftLabel);
      return (
        '<button type="button" class="home-rewards__banner-gift" data-open-flavor-modal="' +
        escapeHtml(gift.instantModal) +
        '">' +
        escapeHtml(gift.giftLabel) +
        '</button>'
      );
    }

    var namesHtml = joinGiftNameParts(gifts.map(giftButtonHtml), locale);
    var namesPlain = joinGiftNameParts(
      gifts.map(function (g) {
        return g.giftLabel;
      }),
      locale,
    );
    var anyModal = gifts.some(function (g) {
      return g.modalable;
    });
    if (anyModal) {
      textEl.innerHTML =
        locale === 'en'
          ? "You'll get 1 free " + namesHtml + ' in your next box!'
          : 'Je krijgt 1 gratis ' + namesHtml + ' in je volgende doos!';
    } else {
      textEl.textContent =
        locale === 'en'
          ? "You'll get 1 free " + namesPlain + ' in your next box!'
          : 'Je krijgt 1 gratis ' + namesPlain + ' in je volgende doos!';
    }
  }

  function renderTrack(root, slots, locale) {
    var track = root.querySelector('[data-bz-sf-punch-track]');
    if (!track) return;
    track.innerHTML = '';
    (slots || []).forEach(function (slot) {
      var item = document.createElement('div');
      var classes = ['home-rewards-punch__item', 'home-rewards-punch__item--' + slot.state];
      if (slot.modalable) classes.push('home-rewards-punch__item--modalable');
      item.className = classes.join(' ');
      item.setAttribute('data-doos', String(slot.doos));
      if (slot.key) item.setAttribute('data-gift-key', slot.key);

      if (slot.modalable && slot.instantModal) {
        item.setAttribute('role', 'button');
        item.tabIndex = 0;
        item.setAttribute('data-open-flavor-modal', slot.instantModal);
      }

      var doosLabel = document.createElement('p');
      doosLabel.className = 'home-rewards-punch__doos';
      doosLabel.textContent = (locale === 'en' ? 'BOX ' : 'DOOS ') + slot.doos;
      item.appendChild(doosLabel);

      var circleWrap = document.createElement('div');
      circleWrap.className = 'home-rewards-punch__circle-wrap';
      var circle = document.createElement('div');
      circle.className = 'home-rewards-punch__circle';
      if (slot.imageUrl) {
        var img = document.createElement('img');
        img.className = 'home-rewards-punch__img';
        img.src = slot.imageUrl;
        img.alt = '';
        img.loading = 'lazy';
        circle.appendChild(img);
      }
      circleWrap.appendChild(circle);
      item.appendChild(circleWrap);

      var label = document.createElement('p');
      label.className = 'home-rewards-punch__label';
      var slotLabel =
        slot.type === 'empty' ? '' : (slot.label && (slot.label[locale] || slot.label.nl)) || '';
      label.textContent = slotLabel;
      if (slot.modalable) label.classList.add('home-rewards-punch__label--link');
      item.appendChild(label);

      track.appendChild(item);
    });
  }

  function ensureShell(root) {
    if (!root) return null;
    var card = root.querySelector('.home-rewards-punch-card');
    if (card) {
      var title = root.querySelector('.bz-sf-punch__title');
      if (title && title.tagName === 'H3') {
        var p = document.createElement('p');
        p.className = title.className;
        p.textContent = title.textContent;
        title.parentNode.replaceChild(p, title);
      }
      return root;
    }

    var locale = localeFromDoc();
    root.classList.add('bz-sf-punch');
    root.innerHTML =
      '<div class="home-rewards-punch-card">' +
      '<p class="bz-sf-punch__title">' +
      punchTitleCopy(locale, 7) +
      '</p>' +
      '<div class="home-rewards__banner" data-bz-sf-punch-banner hidden>' +
      '<p class="home-rewards__banner-text" data-bz-sf-punch-banner-text></p>' +
      '</div>' +
      '<div class="home-rewards-punch">' +
      '<div class="home-rewards-punch__track" data-bz-sf-punch-track role="list"></div>' +
      '</div>' +
      '</div>';
    return root;
  }

  function enrichSlotsFromShopify(slots) {
    var ids = [];
    (slots || []).forEach(function (slot) {
      var id = variantNumericId(slot.shopifyVariantId);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return Promise.resolve(slots);

    return Promise.all(
      ids.map(function (id) {
        return fetchVariantMeta(id);
      }),
    ).then(function () {
      return (slots || []).map(function (slot) {
        var id = variantNumericId(slot.shopifyVariantId);
        var meta = id ? variantMetaCache[id] : null;
        if (!meta) return slot;
        var next = Object.assign({}, slot);
        if (slot.type === 'box1_item') {
          if (meta.productImageUrl) next.imageUrl = meta.productImageUrl;
          else if (meta.imageUrl) next.imageUrl = meta.imageUrl;
          if (meta.productTitle) next.label = { nl: meta.productTitle, en: meta.productTitle };
        } else {
          if (meta.imageUrl) next.imageUrl = meta.imageUrl;
          if (slot.type === 'sample' && !slot.isCredit) {
            var sampleTitle = meta.name || meta.title;
            if (sampleTitle) next.label = { nl: sampleTitle, en: sampleTitle };
          }
          if (slot.type === 'product' && meta.title) {
            next.label = { nl: meta.title, en: meta.title };
          }
        }
        return next;
      });
    });
  }

  /**
   * @param {HTMLElement} root
   * @param {{ planFlavors?: string[], allergies?: string[], box1Freebies?: {scoop:boolean,guide:boolean}, visible?: boolean, locale?: string }} opts
   */
  function render(root, opts) {
    opts = opts || {};
    if (!root) return null;
    ensureShell(root);

    var visible = opts.visible !== false && rewardsExperimentOn();
    if (!visible) {
      root.hidden = true;
      return null;
    }
    root.hidden = false;

    var locale = opts.locale || localeFromDoc();
    var samplePick = pickSampleReward(opts.planFlavors, opts.allergies);
    var slots = buildSlots({
      planFlavors: opts.planFlavors,
      allergies: opts.allergies,
      box1Freebies: opts.box1Freebies || { scoop: true, guide: true },
      samplePick: samplePick,
      locale: locale,
    });
    var titleEl = root.querySelector('.bz-sf-punch__title');
    if (titleEl) titleEl.textContent = punchTitleCopy(locale, giftCount(slots));
    var banner = nextBanner(slots, locale);
    renderBanner(root, banner, locale);
    renderTrack(root, slots, locale);

    enrichSlotsFromShopify(slots).then(function (enriched) {
      if (root.hidden) return;
      if (titleEl) titleEl.textContent = punchTitleCopy(locale, giftCount(enriched));
      renderTrack(root, enriched, locale);
      renderBanner(root, nextBanner(enriched, locale), locale);
    });

    return { slots: slots, banner: banner, samplePick: samplePick };
  }

  global.BzStorefrontPunch = {
    render: render,
    rewardsOn: rewardsExperimentOn,
    pickSampleReward: pickSampleReward,
    buildSlots: buildSlots,
  };
})(typeof window !== 'undefined' ? window : this);
